<template>
  <div class="vs-shot" :class="{ 'vs-shot--empty': !src }">
    <!-- Captura -->
    <div v-if="src" class="vs-shot__frame">
      <div class="vs-shot__bar">
        <span class="vs-shot__dot"></span>
        <span class="vs-shot__dot"></span>
        <span class="vs-shot__dot"></span>
      </div>
      <img
        :src="src"
        :alt="alt"
        class="vs-shot__img"
        loading="lazy"
        decoding="async"
        @error="onError"
        @click="$emit('zoom', full_src)"
      />
    </div>

    <!-- Sin captura disponible: placeholder con el icono del feature -->
    <div v-else class="vs-shot__placeholder">
      <v-icon size="56" color="white">{{ icon || "mdi-image-outline" }}</v-icon>
    </div>
  </div>
</template>

<script>
import { candidates } from "@/components/version/releaseImages.js";

export default {
  props: {
    // Nombre del png (sin extensión) dentro de public/img/versions/<version>/
    image: {
      type: String,
      default: null
    },
    version: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: ""
    },
    // Customers que tienen captura propia de esta pantalla
    variants: {
      type: Array,
      default: null
    }
  },
  data: () => ({
    // Índice del candidato que estamos probando. Empezamos por la carpeta del
    // customer para que un cliente con pantallas personalizadas vea las suyas,
    // y por la miniatura para que la pantalla cargue rápido.
    candidate_index: 0
  }),
  computed: {
    // Miniatura ligera (jpg) para la tarjeta, con el png completo de reserva
    candidates() {
      return candidates(this.version, this.image, this.variants);
    },
    src() {
      return this.candidates[this.candidate_index] || null;
    },
    // Al ampliar servimos siempre el png a resolución completa
    full_src() {
      if (!this.src) return null;
      return this.src.replace(/-thumb\.jpg$/, ".png");
    }
  },
  watch: {
    image() {
      this.candidate_index = 0;
    }
  },
  methods: {
    onError() {
      // Probamos el siguiente candidato; si se acaban, mostramos el placeholder.
      this.candidate_index++;
    }
  }
};
</script>

<style scoped>
.vs-shot {
  width: 100%;
}
.vs-shot__frame {
  border-radius: 10px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 12px 30px -12px rgba(15, 23, 42, 0.35);
}
.vs-shot__bar {
  height: 22px;
  background: #f1f3f7;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  padding-left: 10px;
}
.vs-shot__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #d3d7e0;
  margin-right: 5px;
}
.vs-shot__img {
  display: block;
  width: 100%;
  height: auto;
  cursor: zoom-in;
}
.vs-shot__placeholder {
  border-radius: 10px;
  min-height: 190px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #2e21bd 0%, #21b5db 100%);
  opacity: 0.85;
}
</style>
